// libraries
import React from 'react'
import clsx from 'clsx'

// components
import Image from '/react4xp/components/Image'
import AnimatedArrow from '/react4xp/components/AnimatedArrow'

// prop types
interface ProductBlockVerticalProps {
    blockSize: 'small' | 'medium' | 'large'
    href: string
    external?: boolean
    src: string
    srcMobile: string
    alt?: string
    width?: number
    sizes?: string
    title: string
    desc: string
    className?: string
}

export default function ProductBlockVertical({
    blockSize,
    href,
    external,
    src,
    srcMobile,
    alt,
    width,
    sizes,
    title,
    desc,
    className
}: ProductBlockVerticalProps) {
    return (
        <div
            className={clsx(
                'product-block-vertical small',

                // block size
                //blockSize === 'large' && 'large',
                //blockSize === 'medium' && 'medium',
                //blockSize === 'small' && 'small',

                className
            )}
        >
            <a
                href={href}
                target={external ? '_blank' : undefined}
            ></a>
                
            <div className='image'>
                <Image
                    src={src} //500x500
                    srcMedium={srcMobile} // 400x400
                    alt={alt}
                    width={width}
                    sizes={sizes}
                />
            </div>

            <div className='box'>

                <h3 className={clsx(
                    'product-name h3',
                    //blockSize === 'large' && 'h2',
                    //blockSize === 'medium' && 'h3',
                    //blockSize === 'small' && 'h3'
                )}>
                    {title}
                </h3>

                <div
                    className='desc text-big'
                    dangerouslySetInnerHTML={{ __html: desc }}
                    suppressHydrationWarning
                />

                <AnimatedArrow className='arrow' />

            </div>
            
        </div>
    )
}